import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VipinfoComponent } from './vipinfo.component';
import { VipinfoColorsComponent } from './components/vipinfo-colors/vipinfo-colors.component';
import { VipinfoContentsComponent } from './components/vipinfo-contents/vipinfo-contents.component';
import { FormsModule } from '@angular/forms';
import { VipinfoModalComponent } from './components/vipinfo-modal/vipinfo-modal.component';
import { VipinfoEditPopupModalComponent } from './components/vipinfo-modal/components/vipinfo-edit-popup-modal/vipinfo-edit-popup-modal.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ColorPickerModule } from 'ngx-color-picker';

@NgModule({
  declarations: [
    VipinfoComponent,
    VipinfoColorsComponent,
    VipinfoContentsComponent,
    VipinfoModalComponent,
    VipinfoEditPopupModalComponent,
  ],
  imports: [CommonModule, FormsModule, ModalModule, AngularEditorModule, ColorPickerModule],
  exports: [VipinfoComponent],
})
export class VipinfoModule {}
